<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"
import { useRedirect } from "@core/composables/useRedirect"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            heading1: "Bienvenue !",
            sub_title:
                "Un énorme merci pour votre confiance et votre abonnement à notre logiciel de collecte et d'analyse des données énergétiques. 🚀",
            texts_success:
                "Maintenant, c'est à vous de jouer ! Connectez-vous à votre compte et découvrez tout ce que notre super logiciel peut faire pour vous. On est là pour vous aider à économiser de l'énergie et à rendre le monde un peu plus vert, ensemble ! 💚",
            button: "Connectez-vous",
            text_website: "Aller sur Homeys.fr",
            text_contact: "Contactez-nous",
        },
    },
})

// ================================
// COMPOSABLES
// ================================
const { redirectWrapper } = useRedirect()

// ================================
// INTERACTIONS
// ================================
/** Redirige vers la page de connexion (premier login). */
function onLogin(): void {
    redirectWrapper("/login?view=first-login")
}
</script>

<template>
    <BaseCard
        class="subscription-form-success flex flex-col justify-center items-center gap-10 w-full p-8"
        :pt="{
            content: 'flex flex-col justify-center items-center gap-10',
            header: 'flex flex-col justify-center items-center gap-4',
        }"
    >
        <template #header>
            <h1 class="text-xl font-semibold text-primary-900 text-center">
                {{ t("heading1") }}
            </h1>
            <h2 class="text-base font-medium text-primary-800 text-center">
                {{ t("sub_title") }}
            </h2>
        </template>
        <template #content>
            <p class="text-sm text-primary-700 text-center whitespace-pre-line">
                {{ t("texts_success") }}
            </p>
            <BaseButton
                :label="t('button')"
                class="w-full max-w-[280px]"
                @click="onLogin"
            />
            <div
                class="flex flex-row gap-4 items-center justify-center flex-wrap"
            >
                <a
                    href="https://www.homeys.fr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-sm text-primary-600 underline"
                >
                    {{ t("text_website") }}
                </a>
                <span class="text-primary-400">•</span>
                <a
                    href="mailto:contact@homeys.io"
                    class="text-sm text-primary-600 underline"
                >
                    {{ t("text_contact") }}
                </a>
            </div>
        </template>
    </BaseCard>
</template>
